export default "__VITE_ASSET__7VUwu$_d__"